import { Seo } from "@/components/Seo";
import { FindUs, Hero, InfoMarquee } from "@/components/home/HomeTop";
import { FaqTeaser, HowToOrder, InsideStore, TopSellers, VisitSection } from "@/components/home/HomeBottom";
import { DealsSection } from "@/components/Deals";
import { Reviews } from "@/components/home/Reviews";
import { PAGES } from "@/lib/site";

export default function Home() {
  return (
    <>
      <Seo {...PAGES.home} path="/" />
      <Hero />
      <InfoMarquee />
      <DealsSection />
      <FindUs />
      <TopSellers />
      <HowToOrder />
      <Reviews />
      <InsideStore />
      <VisitSection />
      <FaqTeaser />
    </>
  );
}
